/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

/**
 * Request schema for updating a subjective shareback.
 */
export interface SubjectiveSharebackUpdateRequest {
  /** The updated subjective shareback text */
  text: string;
}
